import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { PrivateRoute, PublicRoute } from ".";
import { ThisPaths } from "../shared/Constants";

// Pages
import DiningRoom from "../pages/DiningRoom/DiningRoom";
import Login from "../pages/UserSession/Login";
import Footer from "../components/Footer";
import TotemNavbar from "../components/Header/TotemNavBar";

function TotemRoutes() {
    return (
        <Router>
            <TotemNavbar />
            <Switch>
                <PublicRoute path={ThisPaths.LOGIN} component={Login} />
                <PrivateRoute
                    exact
                    path={ThisPaths.MENU}
                    component={DiningRoom}
                />
                <Redirect to={ThisPaths.LOGIN} />
            </Switch>
            <Footer />
        </Router>
    );
}

export default TotemRoutes;
